export default __webpack_public_path__ + "static/media/Banrisul.f757a78d.svg";